import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

const CONNECTION_STRING =
  process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING ?? '';

export const reactPlugin = new ReactPlugin();
export const appInsights = new ApplicationInsights({
  config: {
    connectionString: CONNECTION_STRING,
    enableAutoRouteTracking: true,
    extensions: [reactPlugin],
  },
});

if (CONNECTION_STRING) {
  appInsights.loadAppInsights();
}
